import locale from "localization";
import styles from "./shift-details-stock-inventory.module.scss";
import { Title } from "components/commons";
import { dryStockSalesMapper } from "./shift-details-stock-inventory.mapper";
import { dryStockLPGSalesColumn } from "./shift-details-stock-inventory-column";
import useDataTable from "hooks/useDataTable";
import { initialFilterState } from "modules/shift-records/shift-records-filter.state";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { filter } from "lodash";
import Big from "big.js";

const ShiftDetailsDryStockSalesLpg = ({ shift }) => {
  const lpgs = filter(shift?.transactionItem.nonFuel, { type: "lpg" });
  const lpgPremiumDiscount = filter(shift?.transactionPaymentMethod?.cash, {
    type: "lpg",
  });

  console.log("dryStockData", shift);
  const formattedList = lpgs.map((lpg) => {
    // const totalDiscount = lpg?.originalTotalAmount - lpg?.netTotalAmount;

    // const premiumDiscount = lpgPremiumDiscount.find((premium) => premium.sku === lpg.sku);

    const premiumDiscount = lpgPremiumDiscount.find((premium) => premium.sku === lpg.sku);

    // const discountMagnitude = isVatExempt
    //   ? 0
    //   : (lpg.originalTotalAmount ?? 0) -
    //     (lpg.netTotalAmount ?? lpg.originalTotalAmount ?? 0);
    // const totalDiscount = -discountMagnitude;
    // const finalAmount = isVatExempt
    //   ? lpg.originalTotalAmount - vatAdjustment
    //   : lpg.netTotalAmount != null
    //   ? lpg.netTotalAmount
    //   : lpg.originalTotalAmount - discountMagnitude;
    // const vatExemptAmount = isVatExempt
    //   ? -(lpg.originalTotalAmount - lpg.originalTotalAmount / 1.12)
    //   : 0;

    let totalDiscount = Number(
      Big(lpg.originalTotalAmount)
        .minus(lpg.netTotalAmount)
        .minus(Math.abs(lpg.vatExempt12percent))
        .mul(-1)
        .round(2)
    );
    let vatExemptAmount = lpg.vatExempt12percent;
    const finalAmount = lpg.originalTotalAmount + totalDiscount + vatExemptAmount;

    return {
      ...lpg,
      totalDiscount,
      finalAmount,
      premiumDiscount,
      vatExemptAmount,
    };
  });

  const { table } = useDataTable({
    value: formattedList,
    filter: { initialState: initialFilterState(), mapper: (val) => val },
    table: {
      key: "nonFuel",
      name: "dryStockSales",
      mapper: (val) => dryStockSalesMapper({ val }),
      columns: dryStockLPGSalesColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.lpgSales}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsDryStockSalesLpg;
